import { render, staticRenderFns } from "./party-role.vue?vue&type=template&id=27f4a106&scoped=true&"
import script from "./party-role.vue?vue&type=script&lang=js&"
export * from "./party-role.vue?vue&type=script&lang=js&"
import style0 from "./party-role.vue?vue&type=style&index=0&id=27f4a106&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f4a106",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
